import { defineComponent, getCurrentInstance, h } from "vue";
import { CdrModal } from "@rei/cedar";
import _sfc_main from "../../components/Modals/AddToCartErrorModal/AddToCartErrorModal.mjs";
import _sfc_main$1 from "../../components/Modals/AddToWishlistModal/AddToWishlistModal.mjs";
/* empty css                                                              */
import DisclaimerModal from "../../components/Modals/DisclaimerModal/DisclaimerModal.mjs";
import DividendModal from "../../components/Modals/DividendModal/DividendModal.mjs";
import _sfc_main$3 from "../../components/Modals/ShippingTermsModal/ShippingTermsModal.mjs";
/* empty css                                                              */
import _sfc_main$2 from "../../components/Modals/HTMLContentModal/HTMLContentModal.mjs";
/* empty css                                                          */
import MapMessageModal from "../../components/Modals/MapMessageModal/MapMessageModal.mjs";
import NewMemberOfferDetailsModal from "../../components/Modals/NewMemberOfferDetailsModal/NewMemberOfferDetailsModal.mjs";
import OversizeShipModal from "../../components/Modals/OversizeShipModal/OversizeShipModal.mjs";
import Prop65Modal from "../../components/Modals/Prop65Modal/Prop65Modal.mjs";
import RetentionBillboardModal from "../../components/Modals/RetentionBillboardModal/RetentionBillboardModal.mjs";
import SizeChartModal from "../../components/Modals/SizeChartModal/SizeChartModal.mjs";
import SizeFinderModal from "../../components/Modals/SizeFinderModal/SizeFinderModal.mjs";
import KidsSizeFinderModal from "../../components/Modals/KidsSizeFinderModal/KidsSizeFinderModal.mjs";
import StorePickupModal from "@rei/store-pickup-modal";
import PreorderModal from "../../components/Modals/PreorderModal/PreorderModal.mjs";
import TermsAndConditionsModal from "../../components/Modals/TermsAndConditionsModal/TermsAndConditionsModal.mjs";
import { ADD_TO_CART_PICKUP_FLOW, CLOSE_MODAL, HANDLE_WISHLIST_FLOW, HANDLE_RECS_CLICK, HANDLE_STORE_SEARCH_CLICK, HANDLE_GEOLOCATION_CLICK, UPDATE_STORE_SEARCH_BOX_REF, METRICS_CLICK, OPEN_PREORDER_MODAL, HANDLE_ACCEPT_TERMS, HANDLE_LOGIN, ADD_MEMBERSHIP_AND_SKU, HANDLE_FEET_SELECT_CHANGE, HANDLE_INCHES_SELECT_CHANGE, CLEAR_MODAL_DATA } from "../../store/constants.mjs";
import ProductReviewsReviewModal from "../../components/ProductReviews/ProductReviewsReviewModal/ProductReviewsReviewModal.mjs";
import useProductReviewsStore from "../../stores/productReviewsStore.mjs";
const ModalContainer = defineComponent({
  name: "ModalContainer",
  components: {
    AddToCartErrorModal: _sfc_main,
    AddToWishlistModal: _sfc_main$1,
    DisclaimerModal,
    DividendModal,
    HTMLContentModal: _sfc_main$2,
    MapMessageModal,
    NewMemberOfferDetailsModal,
    OversizeShipModal,
    PreorderModal,
    Prop65Modal,
    ProductReviewsReviewModal,
    RetentionBillboardModal,
    ShippingTermsModal: _sfc_main$3,
    SizeChartModal,
    SizeFinderModal,
    KidsSizeFinderModal,
    StorePickupModal,
    TermsAndConditionsModal
  },
  props: {
    modalClass: {
      type: String,
      required: true
    }
  },
  render() {
    const instance = getCurrentInstance();
    const { components } = instance == null ? void 0 : instance.type;
    const {
      state,
      getters,
      commit,
      dispatch
    } = this.$store;
    const newProps = typeof state.modalData.modalProps === "string" ? getters[state.modalData.modalProps] : state.modalData.modalProps;
    const { modalContent } = state.modalData;
    const { enablePinia, showNativeReviews } = getters.appPropsMap.launchToggles;
    const useNativeReviews = enablePinia && showNativeReviews;
    const productReviewsStore = useNativeReviews ? useProductReviewsStore() : {
      handleIndividualReviewFeedback: () => {
      }
    };
    const dynamicComponent = modalContent ? h(
      components[modalContent],
      {
        // if modalProps is an object, pass through. If a string, it points to a getter
        // getter usage is required if the modal content is dynamic
        ...newProps,
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        onAddToCartPickup: (storeEntry) => dispatch(ADD_TO_CART_PICKUP_FLOW, storeEntry),
        onModalClose: () => dispatch(CLOSE_MODAL),
        onWishlistSelect: (wishlist) => dispatch(HANDLE_WISHLIST_FLOW, wishlist),
        onRecsClick: (data) => dispatch(HANDLE_RECS_CLICK, { data }),
        onStoreSearchClick: (value) => dispatch(HANDLE_STORE_SEARCH_CLICK, value),
        onGetUserLocation: () => dispatch(HANDLE_GEOLOCATION_CLICK),
        onRegisterSPSearchRef: (ref) => commit(UPDATE_STORE_SEARCH_BOX_REF, ref),
        onMetricsClick: (data) => dispatch(METRICS_CLICK, data),
        onPreorderBannerClick: () => dispatch(OPEN_PREORDER_MODAL),
        onAcceptTerms: () => dispatch(HANDLE_ACCEPT_TERMS),
        onDeclineTerms: () => dispatch(CLOSE_MODAL),
        onSignin: () => dispatch(HANDLE_LOGIN),
        onAddToCart: () => dispatch(ADD_MEMBERSHIP_AND_SKU),
        onFeetSelectChange: (data) => dispatch(HANDLE_FEET_SELECT_CHANGE, data),
        onInchesSelectChange: (data) => dispatch(HANDLE_INCHES_SELECT_CHANGE, data),
        onIndividualReviewFeedbackClick: (body) => {
          productReviewsStore.handleIndividualReviewFeedback(body);
        }
      }
    ) : "";
    return h(CdrModal, {
      // Note: legacy "id" may be used for both UI tests and accessibility,
      // all future tests should be based off data-ui
      "data-ui": state.modalData.id,
      "data-modal-state": state.modalIsOpen && "open",
      class: state.modalData.class,
      id: state.modalData.id,
      opened: state.modalIsOpen,
      label: state.modalData.label,
      showTitle: state.modalData.labelIsTitle,
      ariaDescribedby: state.modalData.ariaDescribedBy,
      contentClass: state.modalData.contentClass ? state.modalData.contentClass : this.modalClass,
      wrapperClass: state.modalData.wrapperClass,
      role: dynamicComponent ? "dialog" : "",
      onClosed: () => {
        dispatch(CLOSE_MODAL, true);
        setTimeout(() => commit(CLEAR_MODAL_DATA), 200);
      }
    }, () => [dynamicComponent]);
  }
});
export {
  ModalContainer as default
};
//# sourceMappingURL=ModalContainer.mjs.map
